"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgStatusWarningSmall = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 22, height: 20, fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M21.474 15.652 13.337 1.72a2.671 2.671 0 0 0-.987-.954 2.748 2.748 0 0 0-2.681 0 2.672 2.672 0 0 0-.987.954L.526 15.652a2.576 2.576 0 0 0 .001 2.623c.236.399.576.73.984.96.408.23.871.35 1.342.349h16.293c.472 0 .935-.12 1.343-.35.409-.23.748-.56.984-.959a2.575 2.575 0 0 0 .001-2.623Z", fill: "#fff" }), (0, jsx_runtime_1.jsx)("path", { d: "M11 6.843a.942.942 0 0 0-.658.266.9.9 0 0 0-.273.644v4.55a.9.9 0 0 0 .273.644.942.942 0 0 0 1.316 0 .9.9 0 0 0 .273-.644v-4.55a.9.9 0 0 0-.273-.644.942.942 0 0 0-.658-.266ZM11 15.943a.92.92 0 0 0 .931-.91.92.92 0 0 0-.931-.91.92.92 0 0 0-.931.91c0 .503.417.91.931.91Z" })] }))); };
exports.default = SvgStatusWarningSmall;
